import { render, staticRenderFns } from "./Future.vue?vue&type=template&id=39bee2ae&scoped=true"
import script from "./Future.vue?vue&type=script&lang=js"
export * from "./Future.vue?vue&type=script&lang=js"
import style0 from "./Future.vue?vue&type=style&index=0&id=39bee2ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bee2ae",
  null
  
)

export default component.exports